import { MainView } from '../components/layout/main'
import Sidebar from '../components/layout/sidebar/sidebar'
import { Page, PageHeader } from '../ui'
import { OmnibusClaimsView } from '../components/views/omnibusClaimsView'

function OmnibusClaims() {
    return (
        <div className="omnibusClaims">
            <Sidebar />
            <MainView>
                <Page>
                    <PageHeader
                        eyebrow="Sentinel Tools"
                        title="Omnibus Claims"
                        intro="Omnibus groups organise funded claims by lender for schedule submission. Metrics below reflect the groups listed in the table (one unlimited group per lender for now)."
                    />
                    <OmnibusClaimsView />
                </Page>
            </MainView>
        </div>
    )
}

export default OmnibusClaims
